import Vue from"vue";Vue.directive("scroll-to-top",{bind(o,l){o.onclick=o=>{$("html, body").animate({scrollTop:0},"slow")}}});